import { render, staticRenderFns } from "./DataAccessEdit.vue?vue&type=template&id=0d4cf562"
import script from "./DataAccessEdit.vue?vue&type=script&lang=js"
export * from "./DataAccessEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports